import * as messages from 'common/constants/messages/validations';
import { emailValidatorBase } from 'common/constants/userSchemaBase';
import { ValidationConstraints } from './LogInForm.props';

export const constraints: ValidationConstraints = {
  mail: {
    presence: {
      allowEmpty: false,
      message: messages.IS_REQUIRED,
    },
    length: {
      maximum: 128,
      minimum: 5,
      message: messages.REQUIRE_CHARACTERS(5),
    },
    ...emailValidatorBase,
  },
  password: {
    presence: {
      allowEmpty: false,
      message: messages.IS_REQUIRED,
    },
    length: {
      maximum: 128,
      minimum: 9,
      message: messages.REQUIRE_CHARACTERS(9),
    },
    type: {
      type: 'string',
      message: messages.REQUIRE_ONE_LETTER,
    },
    excludeWhiteSpaces: {
      message: messages.HAS_WHITE_SPACES,
    },
    differentThan: {
      field: 'mail',
      message: messages.SIMILAR_TO('user name'),
    },
  },
};
